import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import RequestForm from "./pages/RequestForm";
import Requests from "./pages/Requests";
import RequestDetail from "./pages/RequestDetail";
import UsersPage from "./pages/UsersPage";
import GemsPage from "./pages/GemsPage";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import Notifications from "./pages/Notifications";
import Profile from "./pages/Profile";

const ALL_ROLES = ["Employee", "Manager", "HR", "Director"];
const STAFF_ROLES = ["Manager", "HR", "Director"];
const HR_DIRECTOR = ["HR", "Director"];
const DIRECTOR_ONLY = ["Director"];

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center bg-vault-bg text-vault-panel">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/app/dashboard" replace />;
  return <Layout>{children}</Layout>;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/app/dashboard" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
          <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />

          <Route path="/app/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/app/request/new" element={<Protected roles={ALL_ROLES}><RequestForm /></Protected>} />
          <Route path="/app/requests" element={<Protected><Requests /></Protected>} />
          <Route path="/app/requests/:id" element={<Protected><RequestDetail /></Protected>} />
          <Route path="/app/users" element={<Protected roles={STAFF_ROLES}><UsersPage /></Protected>} />
          <Route path="/app/gems" element={<Protected><GemsPage /></Protected>} />
          <Route path="/app/reports" element={<Protected roles={HR_DIRECTOR}><Reports /></Protected>} />
          <Route path="/app/settings" element={<Protected roles={DIRECTOR_ONLY}><Settings /></Protected>} />
          <Route path="/app/notifications" element={<Protected><Notifications /></Protected>} />
          <Route path="/app/profile" element={<Protected><Profile /></Protected>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
